import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { ImportBranchDto } from './importBranchDto'
import { PermissionDto } from './permissionDto'

export class PersonDto {
  personGuid?: string = undefined
  firstName: string = ''
  lastName: string = ''
  company?: CompanyDto = undefined
  title?: string = undefined
  email?: string = undefined
  mobilePhone?: string = undefined
  officePhone?: string = undefined
  notes?: string = undefined
  isActive?: boolean = true
  isDriver?: boolean = false
  isDeclarant?: boolean = false
  isDeclarationOfOwnershipSigner?: boolean = false
  isEmployee?: boolean = false
  isTitleClerk?: boolean = false
  isUser?: boolean = false
  isConformitySigner?: boolean = false
  allowUserToSignIn?: boolean = false

  permissions?: PermissionDto[] = []
  defaultImportBranch?: ImportBranchDto | null = undefined
}

export const personValidationSchema = yup.object({
  id: yup.string().nullable(),
  firstName: yup.string().required('First Name is required.').max(200, 'First Name cannot be more than 200 characters.'),
  lastName: yup.string().required('Last Name is required.').max(200, 'Last Name cannot be more than 200 characters.'),
  company: yup
    .object()
    .nullable()
    .when('isDriver', {
      is: true,
      then: schema => schema.required('Company is required when Driver is selected')
    }),
  title: yup.string().max(200, 'Title cannot be more than 200 characters.').nullable(),
  email: yup.string().email('Please enter a valid email address.').max(320, 'Email cannot be more than 320 characters.').nullable(),
  mobilePhone: yup.string().max(50, 'Mobile Phone cannot be more than 50 characters.').nullable(),
  officePhone: yup.string().max(50, 'Office Phone cannot be more than 50 characters.').nullable(),
  notes: yup.string().max(2_000, 'Notes cannot be more than 2,000 characters.').nullable(),
  isActive: yup.boolean(),
  isDriver: yup.boolean().test('is-valid-driver', 'Company must be an inbound or outbound transporter', function (value) {
    const { company } = this.parent
    if (value && company) {
      const { isInboundTransporterCompany, isOutboundTransporterCompany } = company
      if (!isInboundTransporterCompany && !isOutboundTransporterCompany) {
        return false
      }
    }

    return true
  }),
  isDeclarant: yup.boolean(),
  allowUserToSignIn: yup.boolean()
})
